export function bumpLabel(label, bump) {
    const [ma, mi, pa] = label.split('.').map((n) => Number(n) || 0);
    switch (bump) {
        case 'major':
            return `${ma + 1}.0.0`;
        case 'minor':
            return `${ma}.${mi + 1}.0`;
        case 'patch':
            return `${ma}.${mi}.${pa + 1}`;
        default:
            return label;
    }
}
//# sourceMappingURL=semver.js.map